import React, { useState, useEffect } from 'react';
import { Col, Label, Input, Button, FormGroup } from 'reactstrap';
import { ComponentCard } from '../layout/ComponentCard';
import { Loader } from '../layout/Loader';
import { Instancia } from '../helpers/axios';
import logger from '../../../services/logger/logger';

export const ListadoGrupos = ({
  id,
  local,
  userSession,
  setId,
  next,
  setNombreGrupo,
  beginning,
  previous,
  empresaId,
  setCodigoGrupo,
  variant,
  deployment,
  idDelegacion,
  mode,
}) => {
  const leadParam = mode === 'presupuesto' ? '&isLead=true' : '';
  // Preparamos variables necesarias
  const [data, setData] = useState([]);
  const [dataGrupos, setDataGrupos] = useState([]);
  const [alreadyTakingCourse, setAlreadyTakingCourse] = useState(false);

  const fullName = `${local.nombre} ${local.apellidos}`;

  // Efectos
  useEffect(() => {
    peticionesApi();
  }, []);

  // Función para las peticiones a API
  const peticionesApi = async () => {
    // Declaramos instancia de axios
    const instance = Instancia(deployment);

    // peticiones a la API
    try {
      // Petición para obtener grupos
      const grupos = await instance.get(
        `buscarGrupos?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}&edit=false&alumnoId=${local.id}&idDelegacion=${idDelegacion.idCedesca}${leadParam}`,
      );
      setData(grupos.data);

      grupos.data.forEach((grupo) => {
        if (grupo.estado_cursando === 'Cursando') {
          setAlreadyTakingCourse(true);
        }
      });

      // Petición para obtener cursos aprobados
      const cursosAprobados = await instance.get(
        `cursosAprobados?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}&id=${local.id}${leadParam}`,
      );
      setDataGrupos(cursosAprobados.data);
    } catch (error) {
      // Si se produce un error, lo registramos sin recargar para evitar loop infinito
      logger.error('Error en ListadoGrupos:', error);
      sessionStorage.setItem('apiError', error);
    }
  };

  // Función que gestiona los inputs
  const handleOnChange = (e) => {
    setId(e.target.value);
    setNombreGrupo(e.target.name);
    setCodigoGrupo(e.target.id);
  };

  return (
    <Col md="12">
      <ComponentCard
        name={fullName}
        title={`Listado de grupos - ${empresaId}`}
        className="clearfix"
      >
        {data.length === 0 ? (
          <Loader />
        ) : (
          <>
            {data.map((option) => {
              let isIn = false;

              dataGrupos.forEach((element) => {
                if (element.codigo_oficial === option.codigo_oficial) {
                  isIn = true;
                }
              });
              if (variant === 'portal') {
                if (option.añosemestrec.includes('ACV')) {
                  option.añosemestrec = 'Antiguo currículum';
                } else if (option.añosemestrec.includes('NCV')) {
                  option.añosemestrec = 'Nuevo currículum';
                }
              }

              return (
                <FormGroup key={option.id}>
                  <Label
                    className={
                      isIn || (alreadyTakingCourse && option.estado_cursando === 'No Cursando')
                        ? 'text-black-50'
                        : ''
                    }
                  >
                    <Input
                      type="radio"
                      id={option.id.toString()}
                      name={`${option.ciclo} - ${option.añosemestrec}`}
                      value={option.id}
                      onChange={handleOnChange}
                      checked={id === option.id.toString()}
                      disabled={
                        isIn || (alreadyTakingCourse && option.estado_cursando === 'No Cursando')
                      }
                      style={{ position: 'inherit', opacity: 1, marginRight: '5px' }}
                    />{' '}
                    {option.ciclo}
                    {!option.añosemestrec.includes('currículum') && variant === 'portal'
                      ? ''
                      : ` - ${option.añosemestrec}`}{' '}
                    {isIn ? ' - Ya completado' : ''}
                    {!isIn && alreadyTakingCourse && option.estado_cursando === 'No Cursando'
                      ? ' - Ya estás cursando otro ciclo'
                      : ''}
                  </Label>
                </FormGroup>
              );
            })}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {variant === 'portal' ? (
                <Button className="float-end me-1" onClick={beginning}>
                  Volver a detalles
                </Button>
              ) : (
                <Button className="float-end me-1" onClick={previous}>
                  Atrás
                </Button>
              )}
              <Button className="float-end" disabled={id === ''} onClick={() => next(0)}>
                Siguiente
              </Button>
            </div>
          </>
        )}
      </ComponentCard>
    </Col>
  );
};
